import React from 'react';
import Button from 'material-ui/Button';

 const CommonButton=({onClick,children, nameClass})=>{
    return <Button variant="raised" color="primary" className={nameClass ? nameClass : 'common-button'} onClick = {onClick}>{children}</Button>
};

export default CommonButton;